<script>
    import { computed, onMounted,ref } from 'vue'
    import { useStore } from 'vuex'
    import { EventBus } from "../../event-bus.js";
    export default {
        name: "RegionNavigation",
        setup(){
          const disclaimer =  ref(false)
          const store = useStore();
          const classes = computed(() => {
                return [ "region-navigation", {
                    open: store.state.navigation.main,
                    "region-navigation-disclaimer": disclaimer.value
                }];
        });

        onMounted(() => {
          if(document.getElementsByClassName("menu-disclaimer").length > 0) {
            if(window.innerWidth < 960) {
              disclaimer.value = true
            }
          }
        })

        return  { classes, EventBus }
      }
    }
</script>

<style lang="sass">
    @import ../../common/styles/settings
    @import region-navigation
</style>
